export default {
    key: 'locations',
    label: 'Locations',
    component: {
        name: 'LocationsTemplate',
        loader: () => import('./LocationsTemplate')
    },
    modules: {
        locations: [
            {
                label: 'Modules',
                name: 'default'
            },
        ]
    }
};
